import { WplywContext } from "../../../../../../context/wplywContext";
import { useContext } from "react";
import { useState } from "react";
import InnerStage1 from "./InnerStage1/InnerStage1";
import InnerStage2 from "./InnerStage2/InnerStage2";
import InnerStage3 from "./InnerStage3/InnerStage3";
import InnerStage1Checker from "../InnerStagesCheckers/InnerStage1Checker";
import InnerStage2Checker from "../InnerStagesCheckers/InnerStage2Checker";
import InnerStage3Checker from "../InnerStagesCheckers/InnerStage3Checker";
import { useEffect } from "react";
import { useActiveTab } from "../../../../../../context/activeTabContext";
import { ConfirmStatusManual } from "../../../MainWrapper/Confirm/ConfirmStatus";
import numberFormat from "../../../../../../components/numberFormat";
import useStage1 from "../../../StagesChecker/stage1";
import useStage2 from "../../../StagesChecker/stage2";
import isCan from "../../../../../../components/isCan";
import { useAuth } from "../../../../../../context/AuthContext";

const InnerStages = (props) => {
	const { selectedPerson, deepLink } = props;
	const { activeTabX, setActiveTab } = useActiveTab();
	const { user } = useAuth();
	const perms = user.perms;
	const deepLinkActive = !!deepLink?.personid;
	const { wplyw } = useContext(WplywContext);
	// Load activetab from localStorage or default to "1"
	const [activetab, setAtiveTab] = useState(() => {
		const storedTab = localStorage.getItem("innerActiveTab");
		return deepLinkActive ? "3" : storedTab || "1";
	});

	// Save the active tab to localStorage whenever it changes
	useEffect(() => {
		localStorage.setItem("innerActiveTab", activetab);
		setActiveTab({
			activeKey: "3",
			innerActiveKey: activetab,
			personid: selectedPerson?.msr_persons_own_id,
		});
	}, [activetab]);

	useEffect(() => {
		if (deepLinkActive) {
			setAtiveTab("3");
			localStorage.setItem("innerActiveTab", "3");
			setActiveTab({
				activeKey: "3",
				innerActiveKey: "3",
				personid: selectedPerson?.msr_persons_own_id,
			});
		}
	}, [deepLinkActive]);

	useEffect(() => {
		const selectedPersonOwnId = String(
			selectedPerson?.msr_persons_own_id ?? "",
		);
		const storedPersonOwnId = String(
			localStorage.getItem("personid") ?? "",
		);

		if (!selectedPersonOwnId) {
			return;
		}

		if (deepLinkActive) {
			localStorage.setItem("personid", selectedPersonOwnId);
			return;
		}

		if (selectedPersonOwnId !== storedPersonOwnId) {
			setAtiveTab("1");
			localStorage.setItem("innerActiveTab", "1");
			setActiveTab({
				activeKey: "3",
				innerActiveKey: "1",
				personid: selectedPerson?.msr_persons_own_id,
			});
		}
		localStorage.setItem("personid", selectedPersonOwnId);
	}, [selectedPerson.msr_persons_own_id, deepLinkActive]);

	const [candoKwoty, setCandoKwoty] = useState(false); // Stan dla uprawnień
	const [candoRachunki, setCandoRachunki] = useState(false); // Stan dla uprawnień
	const [candoPodsumowanie, setCandoPodsumowanie] = useState(false); // Stan dla uprawnień

	useEffect(() => {
		const fetchPermissions = async () => {
			const requiredPerms = ["can_preview_kwoty"];
			const result = await isCan(requiredPerms, perms);
			setCandoKwoty(result);
		};
		fetchPermissions();
	}, [perms]);

	useEffect(() => {
		const fetchPermissions = async () => {
			const requiredPerms = ["can_preview_rachunki"];
			const result = await isCan(requiredPerms, perms);
			setCandoRachunki(result);
		};
		fetchPermissions();
	}, [perms]);

	useEffect(() => {
		const fetchPermissions = async () => {
			const requiredPerms = ["can_confirm_transfers"];
			const result = await isCan(requiredPerms, perms);
			setCandoPodsumowanie(result);
		};
		fetchPermissions();
	}, [perms]);

	const innerstages = [
		{
			key: "1",
			title: "Kwoty",
			component: (
				<InnerStage1 selectedPerson={selectedPerson}></InnerStage1>
			),
			ready: false,
			blocked: !candoKwoty,
			isConfirmed: ConfirmStatusManual({
				activeKey: 3,
				innerActiveKey: 1,
				personid: selectedPerson.msr_persons_own_id,
			}),
		},
		{
			key: "2",
			title: "Rachunki",
			component: (
				<InnerStage2 selectedPerson={selectedPerson}></InnerStage2>
			),
			ready: false,
			blocked: !InnerStage2Checker(selectedPerson) || !candoRachunki,
			isConfirmed: ConfirmStatusManual({
				activeKey: 3,
				innerActiveKey: 2,
				personid: selectedPerson.msr_persons_own_id,
			}),
		},
		{
			key: "3",
			title: "Podsumowanie",
			isHidden: true,
			component: (
				<InnerStage3
					selectedPerson={selectedPerson}
					deepLink={deepLink}
				></InnerStage3>
			),
			ready: false,
			blocked:
				!InnerStage3Checker(selectedPerson) ||
				!InnerStage2Checker(selectedPerson) ||
				!candoPodsumowanie,
		},
	];

	return (
		<div>
			<div
				style={{
					display: "flex",
					width: "100%",
					gap: "10px",
					alignItems: "center",
				}}
			>
				{innerstages.map((x, i) => {
					return (
						<>
							<div
								onClick={() =>
									!x.blocked ? setAtiveTab(x.key) : ""
								}
								style={{
									display: "flex",
									cursor: "pointer",
									gap: "15px",
									alignItems: "center",
									padding: "7px 10px",
									border:
										activetab == x.key
											? "2px solid #BD8136"
											: "1px solid #BD8136",
									borderRadius: "0px",
									width: "100%",
									background:
										activetab == x.key
											? x.isConfirmed
												? "rgb(82, 196, 26)"
												: "rgb(189, 129, 54, 0.2)"
											: x.isConfirmed
												? "rgb(82, 196, 26)"
												: "white",
									cursor: x.blocked
										? "not-allowed"
										: "pointer",
									opacity: x.blocked ? "0.5" : "1",
									color: x.isConfirmed ? "white" : "black",
								}}
							>
								{!x.isHidden ? (
									<div
										style={{
											border: x.isConfirmed
												? "none"
												: "1px solid #BD8136",
											display: "flex",
											justifyContent: "center",
											alignItems: "center",
											borderRadius: "5px",
											background: x.ready
												? "#BD8136"
												: "white",
											height: "25px",
											width: x.isConfirmed ? "0" : "25px",
										}}
									></div>
								) : (
									<div
										style={{
											border: "none",
											display: "flex",
											justifyContent: "center",
											alignItems: "center",
											borderRadius: "0",
											background: "transparent",
											height: "25px",
											width: "0",
										}}
									></div>
								)}
								{x.title}
								{x.isConfirmed ? " - Zatwierdzono" : ""}
							</div>
							{innerstages.length !== i + 1 ? (
								<svg
									style={{ flex: "none" }}
									width="24"
									height="28"
									viewBox="0 0 14 18"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M14 9L-3.13956e-07 17.5L9.53674e-07 0.5L14 9Z"
										fill="#BD8136"
									/>
								</svg>
							) : (
								""
							)}
						</>
					);
				})}
			</div>
			{innerstages.find((x) => x.key === activetab.toString())?.component}
		</div>
	);
};

export default InnerStages;
